import { faProjectDiagram, faQuestion } from "@fortawesome/free-solid-svg-icons";
import { PageConfigs } from "configs/globalInterfaces";

const name = "faqs";

export const CONFIGS: PageConfigs = {
  title: name,
  path: `/${name}`,
  icon: faQuestion,
  apiName: `${name}`,
  apiAddress: "faq",
  routeName: name,
  componentNames: ["faq", `faqs`],
  permissions: [`read:${name}`, `maintain:${name}`],
  routes: {
    all: `/${name}/*`,
    base: `/${name}`,
    list: "/list",
    add: `/add`,
    edit: `/edit/:id`,
  },
};
